const riders = {
    "singular": "Rider",
    "plural" : "Riders",
};

const shipments ={
    "singular": "Shipment",
    "plural": "Shipments"
} 

 export const PEC={
    riders,
    shipments
}

export const getAliasConfig=(list)=>{
    for(let item in list){
        let key = item;
        console.log(key);
        if(PEC[key]){
            console.log(list[key]?.alias);
            PEC[key].singular =  list[key]?.alias?.singular ?? PEC[key].singular;
            PEC[key].plural  = list[key]?.alias?.plural ?? PEC[key].plural;
        }
    }
}